<form>
  <div mat-dialog-content class="air-theme">

    <div fxLayout="row" class="flexwrap">

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }}</mat-label>
          <mat-select name="idType" [(ngModel)]="data.compressedGas.idType" required>
            @for (item of this.data.compressedGasTypes; track item) {
              <mat-option [value]="item.id">
                {{ 'compressedGasType.' + item.translation | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.type.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.lt-md="100%">
        @if (data.compressedGas.idType === 4) {
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.other.label' | translate }}</mat-label>
            <input matInput name="others" [(ngModel)]="data.compressedGas.others" required>
            <mat-error>
              {{ 'protocolEdit.dialog.equipment.other.error' | translate }}
            </mat-error>
          </mat-form-field>
        }
      </div>
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.code.label' | translate }}</mat-label>
          <input matInput name="code" [(ngModel)]="data.compressedGas.code" required>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.code.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.location.label' | translate }}</mat-label>
          <input matInput name="location" [(ngModel)]="data.compressedGas.location">
        </mat-form-field>
      </div>

    </div>

    @if (data.isExecution && data.compressedGas.fromProtocol) {
      <div fxLayout="row" class="flexwrap">
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }} {{ 'common.inProtocol' | translate }}
            </mat-label>
            <mat-select name="idTypeProtocol" [ngModel]="data.compressedGas.idTypeProtocol" disabled>
              @for (item of this.data.compressedGasTypes; track item) {
                <mat-option [value]="item.id">
                  {{ 'compressedGasType.' + item.translation | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          @if (data.compressedGas.idTypeProtocol === 4) {
            <mat-form-field class="campoFormulario">
              <input matInput name="othersProtocol" [(ngModel)]="data.compressedGas.othersProtocol" disabled
                placeholder="{{ 'protocolEdit.dialog.equipment.other.label' | translate }}">
              <mat-error>
                {{ 'protocolEdit.dialog.equipment.other.error' | translate }}
              </mat-error>
            </mat-form-field>
          }
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <input matInput name="codeProtocol" [ngModel]="data.compressedGas.codeProtocol" disabled
              placeholder="{{ 'protocolEdit.dialog.equipment.code.label' | translate }} {{ 'common.inProtocol' | translate }}">
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <input matInput name="locationProtocol" [ngModel]="data.compressedGas.locationProtocol" disabled
              placeholder="{{ 'protocolEdit.dialog.equipment.location.label' | translate }} {{ 'common.inProtocol' | translate }}">
          </mat-form-field>
        </div>
      </div>
    }

    @if (data.isExecution && data.compressedGas.fromProtocol && showReason()) {
      <div fxLayout="column" class="flexwrap">
        <div fxFlex>
          <mat-form-field class="campoFormulario">
            <textarea matInput name="reasonChange" [(ngModel)]="data.compressedGas.reasonChange" required
              placeholder="{{ 'protocolEdit.dialog.confirmSave.reason.label' | translate }}">
              <mat-error>
                {{ 'common.reasonChangeError' | translate }}
              </mat-error>
            </textarea>
          </mat-form-field>
        </div>
        <div fxFlex>
          <mat-checkbox name="showDiffInDeviations" [(ngModel)]="data.compressedGas.showDiffInDeviations">
            {{ 'executionEdit.sensorConfig.showDiffInDeviations.label' | translate }}
          </mat-checkbox>
        </div>
        <div fxFlex>
          <mat-checkbox name="showDiffInObservations" [(ngModel)]="data.compressedGas.showDiffInObservations">
            {{ 'executionEdit.sensorConfig.showDiffInObservations.label' | translate }}
          </mat-checkbox>
        </div>
      </div>
    }
  </div>
  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>